import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { HOME } from "@/constants/testIds";

export default function OneOnOne({ bullets = [], image, onBook }) {
  return (
    <section className="py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-5 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-14 items-center">
        <div className="ev-card-photo relative order-1" style={{ aspectRatio: "4/3" }}>
          <img
            src={image || "https://images.pexels.com/photos/7176026/pexels-photo-7176026.jpeg"}
            alt="1-on-1 coaching session"
            className="w-full h-full object-cover absolute inset-0"
            loading="lazy"
          />
        </div>
        <div className="order-2">
          <h2 className="font-serif-ev text-4xl sm:text-5xl md:text-[3.25rem] leading-[1.05] tracking-tight">
            1-on-1 Coaching Sessions
          </h2>
          <p className="mt-5 text-[15px] md:text-base max-w-lg" style={{ color: "var(--ev-muted)" }}>
            These sessions aren't about judgment — they're about support. Prriyanka meets you exactly where
            you are, guides you gently, and celebrates every small shift.
          </p>
          <ul className="mt-8 space-y-4">
            {bullets.map((b) => (
              <li key={b} className="flex items-start gap-3">
                <span className="mt-0.5 w-6 h-6 rounded-full grid place-items-center flex-shrink-0" style={{ background: "var(--ev-blue-2)" }}>
                  <Check className="w-3.5 h-3.5 text-white" />
                </span>
                <span className="text-[15px] md:text-base" style={{ color: "var(--ev-ink-2)" }}>{b}</span>
              </li>
            ))}
          </ul>
          {onBook && (
            <button data-testid="one-on-one-book-btn" onClick={onBook} className="mt-8 ev-btn ev-btn-primary">
              Book a free session <ArrowRight className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
